import Box, { BoxProps } from '@mui/material/Box';
import clsx from 'clsx';
import classes from './Text.module.scss';

export default function Text({
  children,
  className,
  component = 'p',
  inline,
  variant,
  ...rest
}: TextProps) {
  const variantClass = variant && classes[variant];

  return (
    <Box
      className={clsx(classes.root, variantClass, className)}
      component={component === 'p' && inline ? 'span' : component}
      {...rest}
    >
      {children}
    </Box>
  );
}

export interface TextProps extends BoxProps {
  inline?: boolean;
  variant?: 'error' | 'hint' | 'normal';
}
